import {
  SET_CURRENT_ACTIVE_TAB,
  SET_LATEST_START_DATE,
  SET_LATEST_END_DATE,
  SET_LATEST_TAB,
  SET_LATEST_RADIO_VALUE,
  RESET_LETTERS_REPORTS,
  SET_LAST_12_MONTHS_DOCS,
} from "../actions/LettersReportsActions";

const initialState: LettersReportsInitialState = {
  currentActiveTab: "",
  latestFilterStartDate: "",
  latestFilterEndDate: "",
  latestTabValue: "",
  latestRadioValue: "",
  last12MonthsDocs: [],
  // userADADocsReports
  
};

const LettersReportsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_CURRENT_ACTIVE_TAB:
      return {
        ...state,
        currentActiveTab: action.payload,
      };
    case SET_LATEST_START_DATE:
      return {
        ...state,
        latestFilterStartDate: action.payload,
      };
    case SET_LATEST_END_DATE:
      return {
        ...state,
        latestFilterEndDate: action.payload,
      };
    case SET_LATEST_TAB:
      return {
        ...state,
        latestTabValue: action.payload,
      };
    case SET_LATEST_RADIO_VALUE:
      return {
        ...state,
        latestRadioValue: action.payload,
      };
    case SET_LAST_12_MONTHS_DOCS:
      return {
        ...state,
        setLast12MonthsDocs:action.payload

      };
    case RESET_LETTERS_REPORTS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export interface LettersReportsInitialState {
  currentActiveTab: string;
  latestFilterStartDate: string;
  latestFilterEndDate: string;
  latestTabValue: string;
  latestRadioValue: string;
  last12MonthsDocs: Array<any>;
  
}

export default LettersReportsReducer;
